'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getRadioBool;
function getRadioBool() {
    return [{ code: 'yes', value: 'Yes' }, { code: 'no', value: 'No' }];
}